import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { NavigationMenuCardComponent } from './navigation-menu-card/navigation-menu-card.component';
import { NavigationMenuListComponent } from './navigation-menu-list/navigation-menu-list.component';
import { NavigationMenuNavItemComponent } from './navigation-menu-nav-item/navigation-menu-nav-item.component';
import { FreightlancerPostRoleSelectModule } from '../navigation-primary/shared/freightlancer/post-role-select/freightlancer-post-role-select.module';

@NgModule({
  imports: [
    CommonModule,
    TrackingModule,
    UiModule,
    FreightlancerPostRoleSelectModule,
  ],
  declarations: [
    NavigationMenuCardComponent,
    NavigationMenuListComponent,
    NavigationMenuNavItemComponent,
  ],
  exports: [
    FreightlancerPostRoleSelectModule,
    NavigationMenuCardComponent,
    NavigationMenuListComponent,
    NavigationMenuNavItemComponent,
  ],
})
export class NavigationMenuModule {}
